enum SupportJumpPageStepEnum {
  VERIFICATION = 1,
  ENTER_PASSWORD = 2,
  ACTIVATION = 3,
}

export default SupportJumpPageStepEnum;
